import apiClient from './api';
import { API_ENDPOINTS } from '@/config/api.config';
import type { SaveCreditRateRequest } from '@/types/credit-rate.types';

/**
 * Credit↔USD rate API (management-only, singleton). Returns the backend ResultEntity
 * (`{ success, data }`); callers read `.data`.
 */
class CreditRateService {
  async get() {
    const response = await apiClient.get(API_ENDPOINTS.CREDIT_RATE.GET);
    return response.data;
  }

  async save(payload: SaveCreditRateRequest) {
    const response = await apiClient.post(API_ENDPOINTS.CREDIT_RATE.SAVE, payload);
    return response.data;
  }
}

export const creditRateService = new CreditRateService();
